/**
 * EOE Claim Tab Types
 *
 * Tab definitions are fetched from the backend to ensure consistency
 * with the status-to-tab mapping logic. This file only contains TypeScript
 * types derived from the backend schema.
 */

export const EOE_CLAIM_TABS = [
  { id: 'not-ready', label: 'Not Ready', count_key: 'not_ready' },
  { id: 'ready', label: 'Ready', count_key: 'ready' },
  {
    id: 'pending-approval',
    label: 'Pending Approval',
    count_key: 'pending_approval',
  },
  { id: 'ready-to-send', label: 'Ready to Send', count_key: 'ready_to_send' },
  {
    id: 'pending-payment',
    label: 'Pending Payment',
    count_key: 'pending_payment',
  },
  { id: 'paid', label: 'Paid', count_key: 'paid' },
  {
    id: 'rejected-cancelled',
    label: 'Rejected / Cancelled',
    count_key: 'rejected_cancelled',
  },
] as const;

export type EoeClaimTabId = (typeof EOE_CLAIM_TABS)[number]['id'];
